import { createApp } from 'vue'
import EventLog from './Components/EventLog/event-log.vue';
import { createPinia } from "pinia";
// import '../node_modules/element-plus/theme-chalk/src/notification.scss';
import './Assets/eventLog.scss';
import 'element-plus/dist/index.css';
// import './assets/global.css';
//import './Assets/main.scss';


const pinia = createPinia();
const eventLogApp = createApp(EventLog);
eventLogApp.use(pinia);


eventLogApp.mount('#fv-event-log-wrapper')
